import React from "react";
import { useTranslation } from "react-i18next";
import "./Philosophy.css"; 

const Philosophy = () => {
  const { t } = useTranslation();

  return (
    <section className="philo-section">
      <div className="philo-bg-layer">
        <span className="philo-bg-text">{t("philosophy.bgText")}</span>
      </div>

      <div className="philo-content-wrapper animate-fade-up">
        <span className="philo-category-label">{t("philosophy.badge")}</span>
        
        <h2 className="philo-main-quote">
          {t("philosophy.quote")}
        </h2>
        
        <p className="philo-description">
          {t("philosophy.description")}
        </p>
      </div>
    </section>
  );
};

export default Philosophy;